import { ModalController, Platform } from '@ionic/angular/standalone';
import {
  getModalConfig,
  modalContent,
  shouldShowAsSheetModal,
} from 'src/app/core/services/modal/modal.utils';
import { TournamentDataModel } from 'src/app/core/services/tournament/models/tournament-data-model';
import { ThemeService } from 'src/app/core/services/theme/theme.service';

// Both drawers load on demand, so the tier surfaces that show a tournament card don't carry their
// code until a player taps through.

export async function openTournamentTutorial(
  modalController: ModalController,
  platform: Platform,
  themeService: ThemeService,
  tournamentData: TournamentDataModel,
  isMarbles: boolean,
): Promise<void> {
  const { TournamentTutorialComponent } =
    await import('../../tutorials/tournament-tutorial/tournament-tutorial.component');
  const asSheetModal = shouldShowAsSheetModal(platform, themeService);
  const modal = await modalController.create({
    ...modalContent(TournamentTutorialComponent, { tournamentData, isMarbles }),
    ...getModalConfig(asSheetModal),
  });
  await modal.present();
  await modal.onDidDismiss();
}

export async function openTournamentLeaderboard(
  modalController: ModalController,
  platform: Platform,
  themeService: ThemeService,
  tournamentId: string,
): Promise<void> {
  const { TournamentLeaderboardDrawerComponent } =
    await import('../tournament-leaderboard-drawer/tournament-leaderboard-drawer.component');
  const asSheetModal = shouldShowAsSheetModal(platform, themeService);
  const modal = await modalController.create({
    ...modalContent(TournamentLeaderboardDrawerComponent, { tournamentId }),
    ...getModalConfig(asSheetModal, { mobile: 'custom-modal-height' }),
  });
  await modal.present();
}
